import AntTabs from "antd/es/tabs";
import styled from "styled-components";
import { MOBILE_CREATE_TRADE } from "common/constants";

const Tabs = styled(AntTabs)<{ $hideBorder?: boolean; $isSmall?: boolean }>`
  .ant-tabs-ink-bar {
    background: ${(p) => p.theme.colors.primaryBlue};
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(p) => p.theme.colors.primaryBlue}!important;
  }

  .ant-tabs-tab-btn {
    color: ${(p) => p.theme.colors.textColor};

    @media (min-width: ${MOBILE_CREATE_TRADE}) {
      &:hover {
        color: ${(p) => p.theme.colors.primaryBlue};
      }
    }
  }
  .ant-tabs-nav {
    &::before {
      border-color: ${(p) => p.theme.colors.lightestBorderGrey};
      ${(p) =>
        p.$hideBorder &&
        `
        border: none;
      `}
    }
  }
  .ant-tabs-nav-operations {
    display: none !important;
  }
  &.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {
    overflow-x: auto !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  ${(p) =>
    p.$isSmall &&
    `
      .ant-tabs-tab {
        font-size: ${p.theme.typography.fontSizes.S};
      }
      .ant-tabs-tab + .ant-tabs-tab {
        margin: 0 0 0 20px;
      }
  `}
  ${(p) =>
    p.theme.isNewLook &&
    `
    &.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
      height: 3px;
      border-radius: 3px 3px 0 0;
    }
    /* Tab labels are 500 in both states, so the row doesn't shift when the
       selection moves; the active tab takes the ink bar's blue. */
    .ant-tabs-tab-btn {
      color: ${p.theme.colors.secondaryText};
      font-weight: ${p.theme.typography.fontWeights.MEDIUM};
      @media (min-width: ${MOBILE_CREATE_TRADE}) {
        &:hover {
          color: ${p.theme.colors.titleColor};
        }
      }
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${p.theme.colors.primaryBlue} !important;
      font-weight: ${p.theme.typography.fontWeights.MEDIUM};
    }
  `}
`;

export default Tabs;
